import { TaskPlannerSchemaTypes } from "@bfc-software/api-schemas";

export type TaskPlan =
  TaskPlannerSchemaTypes.components["schemas"]["TaskPlanSummary"];

export type TaskPlanListResponse =
  TaskPlannerSchemaTypes.components["schemas"]["TaskPlanListResponse"];

export type TaskPlanDetail =
  TaskPlannerSchemaTypes.components["schemas"]["TaskPlanDetailResponse"];

export type LoadLocation =
  TaskPlannerSchemaTypes.components["schemas"]["LoadLocation"];

export type DestinationNode =
  TaskPlannerSchemaTypes.components["schemas"]["TaskDetailNode"];

export type PlanActivationStatus =
  TaskPlannerSchemaTypes.components["schemas"]["PlanActivationSummary"]["status"];

/**
 * The activation rollup a plan carries in list responses. `null` on the wire is
 * what "never activated" looks like -- there is no separate flag.
 */
export type PlanActivationState =
  TaskPlannerSchemaTypes.components["schemas"]["TaskPlanActivationState"];

export type ActivationError =
  TaskPlannerSchemaTypes.components["schemas"]["ActivationError"];

/**
 * What we know about a plan's most recent activation while rendering the detail
 * page.
 *
 * Read off `TaskPlanDetailResponse.activation` - the rollup the plan read already
 * carries, whose `null` is what "never activated" looks like. Not by listing
 * `/task-plans/{id}/activations`: that was a second round trip to discover an id
 * and a status the first response already stated, and a listing that failed (or
 * that a fixture never answered) reported a completed plan as never activated.
 *
 * Errors are the one thing the rollup does not carry, so they still come from the
 * per-activation detail read.
 */
export type ActivationView =
  | { kind: "loading" }
  | { kind: "none" }
  | {
      kind: "present";
      status: PlanActivationStatus;
      errors: ActivationError[];
    };

export const PPT_PLAN_OPTIMIZATION_KIND: TaskPlannerSchemaTypes.components["schemas"]["TaskPlanOptimizationPickTaskPPT"]["kind"] =
  "pick_task_ppt";

export const PPT_OPTIMIZATION_KIND: TaskPlannerSchemaTypes.components["schemas"]["TaskOptimizationPickTaskPPT"]["kind"] =
  "pick_task_ppt";
